﻿import LifeguardRole from "@/orm/models/LifeguardRole"
import { Defaults, Options } from "@/orm/models/Setting"
import SettingsRepo from "@/orm/repositories/SettingsRepo"
import { AxiosRepository } from "@pinia-orm/axios"
import { useRepo } from "pinia-orm"

export default class LifeguardRolesRepo extends AxiosRepository<LifeguardRole> {
    use = LifeguardRole

    orderedList () {
        return this.whereNotIn( 'id', [ LifeguardRole.NoLifeguards ] ).get().map( ( role ) => ( { label: role.role, value: role.id } ) )
            .sort( ( a, b ) => a.label.localeCompare( b.label ) )
    }

    update () {
        const authToken = useRepo( SettingsRepo ).getOption( Options.AuthToken, Defaults.AuthToken )

        this.flush()

        return this.api().get( '/catalogs/lifeguardRoles', {
            headers: { Authorization: authToken.length > 0 ? "Bearer " + authToken : "" },
            dataTransformer: ( { data } ) => {
                return data.map( ( line ) => ( {
                    id: parseInt( line.id ),
                    role: String( line.title.cs ),
                    shortcut: ( Object.hasOwn( line, 'shortcut' ) && Object.hasOwn( line.shortcut, 'cs' ) ) ? String( line.shortcut.cs ) : undefined,
                    points: Object.hasOwn( line, 'points' ) ? parseFloat( line.points ) : 1.0
                } ) )
            }
        } )
    }
}
